
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    clubId: number = 0;
    leagueId: number = 0;
    match: any = null;
    leagueName = '';
    matchObs$: Subject<any> = new Subject();

    constructor() { }

    clearMatch() {
        this.match = null;
        this.matchObs$.next(null);
    }
}